import React, { Component } from 'react';
import md5 from 'blueimp-md5';
import { Cell, ActionCell } from '../../components/Table';
import Reactable, {Table, Thead, Th, Tr, Td} from 'reactable';

import { keyedObjToArr } from '../../util';

export class TermsActionsCell extends Component {
	render () {
		return(<ActionCell {...this.props}
                           delete={this.props.deleteTerms.bind(this)}
		/>);
	}
}

export default class TermsConditionsList extends Component {

	render () {
	    let terms = keyedObjToArr(this.props.terms);
		return (
            <Table
                className="table ui-list"
                sortable={['version','filename']}
                noDataText=" No terms and conditions found"
                defaultSort='version'
            >
                <Thead className="list-row header">
                    <Th className="list-cell" column="version">Version</Th>
                    <Th className="list-cell" column="filename">Filename</Th>
                    <Th className="list-cell" column="delete">Delete</Th>
                </Thead>
                {terms.map((termsItem, index) => {
                    return (
                        <Tr className="list-row" key={index}>
                            <Td className="list-cell" column="version">
                                {termsItem.version}
                            </Td>
                            <Td className="list-cell" column="filename">
                                <a href={this.props.files[termsItem.pdf].downloadURL} target='_blank'>
                                    {this.props.files[termsItem.pdf].name}
                                </a>
                            </Td>
                            <Td className="list-cell align-left narrow" column="delete">
                                <TermsActionsCell
                                    item={termsItem}
                                    deleteTerms={this.props.deleteTerms.bind(this)}
                                />
                            </Td>
                        </Tr>
                    );
                }, this)}
            </Table>

		);
	}
}



// WEBPACK FOOTER //
// ./js/components/TermsConditions/TermsConditionsList.js